import { ModalContentToggler } from '@components'

import { ModalProps, withModalConditionalRender } from '@billy/design-system'
import QueryString from 'qs'
import { ReactElement } from 'react'

import { createBankConnectionModalSteps } from './constants/createBankConnectionModalSteps'
import { ShineConnectModalContextProvider } from './contexts/shineConnectModalContext'
import { CreateBankConnectionModalSteps } from './enums/createBankConnectionModalSteps'

type ShineConnectQueryParamType = string | QueryString.ParsedQs | (string | QueryString.ParsedQs)[] | undefined

interface CreateBankConnectionModalProps extends ModalProps {
  code?: ShineConnectQueryParamType
  state?: ShineConnectQueryParamType
}

export const CreateBankConnectionModalComponent = ({
  code,
  state,
  ...props
}: CreateBankConnectionModalProps): ReactElement => {
  if (!state) {
    return <></>
  }

  const isError = String(state) === 'error'
  const initialState = isError ? CreateBankConnectionModalSteps.Error : CreateBankConnectionModalSteps.Confirmation
  const codeValue = code ? String(code) : ''

  return (
    <ShineConnectModalContextProvider modalId={props.id} code={codeValue} state={String(state)}>
      <ModalContentToggler
        initialState={initialState}
        states={createBankConnectionModalSteps}
        withTransition={false}
        size="s"
        closable={false}
        {...props}
      />
    </ShineConnectModalContextProvider>
  )
}

export const CreateBankConnectionModal = withModalConditionalRender(CreateBankConnectionModalComponent)
